import { Box, Icon, Text, Tooltip } from "@chakra-ui/react";
import { Info } from "lucide-react";

const ReportInfoTooltip = ({ description }) => {
  if (!description) return null;

  return (
    <Tooltip.Root>
      <Tooltip.Trigger asChild>
        <span className="reportInfoTrigger" aria-label={description}>
          <Icon as={Info} boxSize="16px" />
        </span>
      </Tooltip.Trigger>
      <Tooltip.Positioner>
        <Tooltip.Content maxW="320px">{description}</Tooltip.Content>
      </Tooltip.Positioner>
    </Tooltip.Root>
  );
};

export const ReportTitleWithInfo = ({ as: Component = "h3", children, description }) => (
  <>
    <Box className="reportTitleWithInfo">
      <Component>{children}</Component>
      <ReportInfoTooltip description={description} />
    </Box>
    {description ? (
      <Text as="p" className="reportPrintContext">
        {description}
      </Text>
    ) : null}
  </>
);

export const ReportSectionIntro = ({ title, description }) => (
  <Box className="reportSectionIntro">
    <ReportTitleWithInfo description={description}>{title}</ReportTitleWithInfo>
  </Box>
);

export default ReportTitleWithInfo;
